// src/api/report/report.api.js

import { publicClient } from "../../config/axiosConfig";

const reportEndpoints = {
  downloadReport: "v2/report/downloads",
};

const reportApi = {
  getDownloadReport: async () => {
    try {
      const response = await publicClient.get(reportEndpoints.downloadReport);

      return { response };
    } catch (err) {
      console.error("Error fetching download report:", err);

      return { err };
    }
  },
};

export default reportApi;
